import React from 'react';
import ReactDOM from 'react-dom';
import angular from 'angular';
import { CallQualitySurvey } from '.';
import { components as Core } from '../../../core';
import service from '../../../../common/services/call-quality-survey.service';
export default angular
    .module('doxy.call.provider-survey-angular', [service])
    .component('callQualitySurvey', {
    //call-quality-survey
    template: `<div></div>`,
    bindings: {},
    controller: function ($element) {
        const render = () => {
            ReactDOM.render(React.createElement(Core.withProviders(CallQualitySurvey), {}), $element[0]);
        };
        this.$onInit = render;
    },
}).name;
